// extracted by mini-css-extract-plugin
module.exports = {"SFullPageOverlay":"FullPageOverlay_SFullPageOverlay__5HxjH","SOverlayContent":"FullPageOverlay_SOverlayContent__R_ocT","SCloseButton":"FullPageOverlay_SCloseButton__ot2OH"};